module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "module-side"
  }, [_c('div', {
    staticClass: "swipe-wrap"
  }, [_c('div', {
    staticClass: "swipe",
    attrs: {
      "id": "leftgoods-swiper1"
    }
  }, [_c('Carousel', {
    attrs: {
      "autoplay": _vm.setting.autoplay,
      "autoplay-speed": _vm.setting.autoplaySpeed,
      "dots": _vm.setting.dots,
      "radius-dot": _vm.setting.radiusDot,
      "trigger": _vm.setting.trigger,
      "arrow": _vm.setting.arrow,
      "height": 440,
      "width": 300
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }, _vm._l((_vm.data), function(item) {
    return _c('CarouselItem', {
      key: item.key
    }, [_c('router-link', {
      attrs: {
        "to": item.to,
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "scrollLoading",
      attrs: {
        "src": item.atturl,
        "height": "440px",
        "alt": item.aname,
        "width": "300px"
      }
    })])], 1)
  }), 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bca80a3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/home-page/home-module/left-ad.vue
// module id = 1545
// module chunks = 1